import { object, string } from 'zod';
export const deleteScheme = object({
    password: string({
        required_error: 'Required field',
    })
        .min(8, 'Password must be more then 8 characters')
        .max(25, 'Password must be less then 25 characters'),
});
export const defaultDeleteValues = { password: '' };
